export const scrollToTarget = ({
    target,
    additionalOffsetTop,
    smooth = true
}: {
    target: HTMLElement;
    additionalOffsetTop?: number;
    smooth?: boolean;
}) => {
    let additionalScrollTop = 0;
    if (additionalOffsetTop !== undefined) {
        additionalScrollTop = additionalOffsetTop;
    }
    const targetRects = target.getBoundingClientRect();
    const behavior = !smooth ? "auto" : "smooth";
    if (target.closest("ux-modal")) {
        target.scrollIntoView({
            behavior: behavior,
            block: "start"
        });
    }
    window.scrollTo({
        left: window.scrollX,
        top: targetRects.top + window.scrollY - additionalScrollTop,
        behavior: behavior
    });
};
